<template lang="pug">
v-container.View.View--CompanyPlaceEdit
    v-snackbar(v-model="showForceWarning" color="error" top :timeout="5000")
      | Attenzione: Ci sono ancora clienti in attesa. Premi di nuovo per forzare l'archiviazione.
    template(v-if="!loading")
      template(v-if="list")
        .text-center.mb-3
          div Stato Lista
          .d-inline-block.mr-3.subtitle-2 Chiusa
          v-switch.d-inline-block.mt-0.pt-0(dense hide-details v-model="listSwitchAction" true-value="open" false-value="close" @change="listOpenClose")
          .d-inline-block.subtitle-2.ml-1 Aperta
        v-card.pa-3.mb-3
          .d-flex.align-center
            .flex-grow-1 Clienti in coda
            div.headline.primary--text {{ list.currentlyWaiting }}
        template(v-if="list.tickets.length && list.nextTicketId")
          .text-center.mb-1 Prossimo in lista
          v-card.mb-6
            v-card-text
              .text-center.headline {{ nextTicket.customerInfo.name }} {{ nextTicket.customerInfo.surname }}
              .text-center
                a(:href="`mailto:${nextTicket.customerInfo.email}`") {{ nextTicket.customerInfo.email }}
              .text-center.QRCode(v-html="nextTicket.qrcode" )
              .headline.text-center Numero {{ nextTicket.number }}
            v-card-actions
              .d-flex.justify-space-around.mt-3(style="width:100%")
                v-btn.error--text.px-6(rounded text @click="setStatus(nextTicket.id, 'noshow')")
                  v-icon(left) mdi-close
                  | Assente
                v-btn.secondary--text.px-6(rounded text @click="setStatus(nextTicket.id, 'served')")
                  v-icon(left) mdi-check
                  | Accetta
        template(v-else)
          .text-center Non c'e' nessuno in lista

        template(v-if="nextTickets.length")
          .d-flex.align-center
            .subtitle-2.my-3.flex-grow-1 Persone Successive
            v-btn(@click="showNextPersons=!showNextPersons" small text outlined)
              v-icon(left) mdi-eye
              | Mostra/Nascondi
          v-list.elevation-2.py-0(v-if="showNextPersons")
            template(v-for="ticket, i in nextTickets")
              v-list-item
                v-list-item-content
                  v-list-item-title {{ ticket.customerInfo.name }} {{ ticket.customerInfo.surname }}
                  v-list-item-subtitle Numero {{ ticket.number }}
                v-list-item-action
                  v-menu(offset-y)
                    template(v-slot:activator="{ on }")
                      v-btn(icon v-on="on")
                        v-icon mdi-delete
                    v-list.pa-0
                      v-list-item
                        v-list-item-title.error--text(@click="setStatus(ticket.id, 'cancelled')")
                          v-icon(left color="error") mdi-delete
                          | Conferma
              v-divider
        template(v-if="prevTickets.length")
          .d-flex.align-center
            .subtitle-2.my-3.flex-grow-1 Persone Passate
            v-btn(@click="showPrevPersons=!showPrevPersons" small text outlined)
              v-icon(left) mdi-eye
              | Mostra/Nascondi
          .py-0(v-if="showPrevPersons")
            template(v-for="ticket, i in prevTickets")
              v-list-item.elevation-0(disabled)
                v-list-item-content
                  v-list-item-title {{ ticket.customerInfo.name }} {{ ticket.customerInfo.surname }}
                  v-list-item-subtitle Numero {{ ticket.number }}
              v-divider

        // buttons
        template(v-if="list.status === 'open'")
          .mb-6
          v-btn.success(@click="dialogCreateTicket=true" fab fixed bottom right style="bottom:5rem")
            v-icon mdi-plus
        template(v-if="!(list.status === 'open')")
          .text-center.my-6
            v-btn.error(small @click="archiveList")
              v-icon(left) mdi-delete
              | Archivia Lista
      template(v-else)
        v-card
          v-card-title {{ location.name }}
          v-card-text
            .subtitle-2 Apri la lista d'attesa e inizia ad organizzare la tua giornata
            ValidationObserver(v-slot="{ invalid, validated, passes }")
              v-form
                v-row
                  v-col.pb-0(cols="12")
                    ValidationProvider(name="N° Persone" rules="min_value:0" v-slot="{ errors }")
                      v-text-field(
                        v-model="createListForm.maxNumTickets"
                        name="numero persone" type="number"
                        :error-messages="errors" hint="Quante persone puoi servire oggi?"
                        label="Dimensione lista" prepend-icon="mdi-account" suffix="persone"
                        min="0"
                      )
                  v-col.py-0(cols="12")
                    span Quando la lista raggiungerà il numero di persone indicato si chiuderà automaticamente non accettando più nuovi ticket
                  v-col(cols="12")
                    ValidationProvider(name="Tempo stimato" rules="required|min_value:1" v-slot="{ errors }")
                      v-text-field(
                        v-model="createListForm.averageWaitingTimePerPerson" required
                        name="tempo stimato" type="number"
                        :error-messages="errors"
                        label="Tempo stimato per persona" suffix="minuti" prepend-icon="mdi-clock-outline"
                        hint="Quanto minuti servono per persona?"
                        min="1"
                        )
                  v-col(cols="12")
                    .text-center
                      v-btn.success(rounded @click="passes(createList)" :disabled="invalid")
                        v-icon(left) mdi-check
                        | Crea lista
      v-dialog(v-model="dialogCreateTicket")
        v-card
          v-card-title
            | Aggiungi cliente
            v-spacer
            v-btn(icon @click="dialogCreateTicket=false")
              v-icon mdi-close
          ValidationObserver(v-slot="{ invalid, validated, passes }")
            v-form
              v-card-text
                ValidationProvider(name="Nome" rules="required" v-slot="{ errors }")
                  v-text-field(
                    v-model="createTicketForm.name" required
                    :error-messages="errors"
                    name="nome"
                    label="Nome" prepend-inner-icon="mdi-account"
                  )
                ValidationProvider(name="Cognome" rules="required" v-slot="{ errors }")
                  v-text-field(
                    v-model="createTicketForm.surname" required
                    :error-messages="errors"
                    name="cognome"
                    label="Cognome" prepend-inner-icon="mdi-account"
                  )
                ValidationProvider(name="Email" rules="required|email" v-slot="{ errors }")
                  v-text-field(
                    v-model="createTicketForm.email" required
                    :error-messages="errors"
                    name="email" type="email"
                    label="Email" prepend-inner-icon="mdi-at"
                  )
                ValidationProvider(name="Telefono" v-slot="{ errors }")
                  v-text-field(
                    v-model="createTicketForm.phone" required
                    :error-messages="errors"
                    name="phone"
                    label="Telefono" prepend-inner-icon="mdi-phone"
                  )
              v-card-actions
                v-spacer
                v-btn.success(@click="passes(createTicket)")
                  v-icon(left) mdi-floppy
                  | Aggiungi
    template(v-else)
      Loading
</template>

<script>
import Loading from "@/components/Loading";
import List from "@/api/List";
import Location from "@/api/Location";
import Ticket from "@/api/Ticket";

export default {
  name: "CompanyListView",
  components: { Loading },
  data() {
    return {
      loading: true,
      location: null,
      list: null,
      showNextPersons: true,
      showPrevPersons: false,

      createListForm: {},

      createTicketForm: {},
      listSwitchAction: false,

      dialogCreateTicket: false,
      loadingCreateTicket: false,

      showForceWarning: false,
      forceArchive: false
    };
  },

  computed: {
    nextTicket: function() {
      if (!this.list) return null;

      return this.list.tickets.find(t => t.id == this.list.nextTicketId);
    },

    nextTickets: function() {
      if (!this.list) return [];
      if (!this.list.nextTicketId) return [];

      const indexOfCurrent = this.list.tickets.findIndex(
        t => t.id == this.list.nextTicketId
      );
      return this.list.tickets
        .slice(indexOfCurrent + 1, this.list.length)
        .filter(t => t.status == "waiting");
    },

    prevTickets: function() {
      if (!this.list) return [];
      if (!this.list.nextTicketId) return this.list.tickets;
      const indexOfCurrent = this.list.tickets.findIndex(
        t => t.id == this.list.nextTicketId
      );
      return this.list.tickets.slice(0, indexOfCurrent);
    }
  },

  async mounted() {
    this.$emit("update:title", "Lista");
    this.loading = true;
    this.location = await Location.get(this.$route.params.location);
    await this.fetchList();
    this.loading = false;
  },

  methods: {
    async setTitle() {
      if (this.list) {
        this.$emit("update:title", "Lista");
      } else {
        this.$emit("update:title", "Apri Lista");
      }
    },
    async fetchList() {
      const lists = await List.get(this.$route.params.location);
      if (lists.length > 0) {
        this.list = lists[0];
        this.listSwitchAction = this.list.status;
      } else {
        this.list = null;
      }
      this.setTitle();
    },

    async createList() {
      this.loading = true;
      this.list = await List.create({
        locationId: this.$route.params.location,
        ...this.createListForm,
        maxNumTickets: this.createListForm.maxNumTickets || 0
      });
      this.listSwitchAction = this.list.status;
      this.setTitle();
      this.loading = false;
    },

    async createTicket() {
      this.loadingCreateTicket = true;
      await Ticket.create({
        waitingListId: this.list.id,
        ...this.createTicketForm
      });
      await this.fetchList();
      this.createTicketForm = {};
      this.loadingCreateTicket = false;
      this.dialogCreateTicket = false;
    },

    async setStatus(ticketId, status) {
      this.loading = true;
      await Ticket.setStatus(ticketId, {
        status
      });
      await this.fetchList();
      this.loading = false;
    },

    async listOpenClose(action) {
      if (action === "open") {
        await this.openList();
      }
      if (action === "close") {
        await this.closeList();
      }
    },

    async closeList() {
      this.loading = true;
      await List.close(this.list.id);
      await this.fetchList();
      this.loading = false;
    },

    async openList() {
      this.loading = true;
      await List.open(this.list.id);
      await this.fetchList();
      this.loading = false;
    },

    async archiveList() {
      this.loading = true;
      try {
        await List.archive(this.list.id, {
          force: this.forceArchive
        });
        this.forceArchive = false;
      } catch (error) {
        if (error.response && error.response.status == 409) {
          this.showForceWarning = true;
          this.forceArchive = true;
          // if no action reset after 15 secs
          setTimeout(() => {
            this.forceArchive = false;
          }, 15 * 1000);
        } else {
          throw error;
        }
      } finally {
        await this.fetchList();
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.QRCode {
  width: 60%;
  margin: 0 auto;
}
</style>
